import React, { Fragment } from 'react'

// icons
import { faBars } from '@fortawesome/free-solid-svg-icons'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import ItemFamilia from './ItemFamilia'

// route
import { withRouter } from 'react-router-dom'
import routes from '../../Routes'
// services

// alert swal
import HeaderActionsButtons from '../Custom/HeaderActionsButtons'
import HeaderPagination from '../Custom/HeaderPagination'
import usePagination from './hooks/usePagination'
import useFamily from './hooks/useFamily'

const visibleButtons = {
    create: true,
    import: true,
    export: true,
    deleted: true,
    search: true,
}

const Familias = ({ history }) => {
    const {
        handleBuscador,
        nextPage,
        previousPage,
        totalRegister,
        totalPage,
        page,
        familias,
        setIsLoad,
    } = usePagination(history, true)

    const { handleImprimir } = useFamily()
    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faBars} title={'Familias'} />
                </div>

                <HeaderActionsButtons
                    history={history}
                    routes={routes.FAMILIA}
                    visibleButtons={visibleButtons}
                    handleImprimir={handleImprimir}
                    handleBuscador={handleBuscador}
                />

                <HeaderPagination
                    page={page}
                    totalPage={totalPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    totalRegister={totalRegister}
                />

                <table className="table table-striped mt-3 text-center">
                    <thead>
                        <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Nombre</th>
                            <th scope="col">Departamento</th>
                            <th scope="col">Ganancia</th>
                            <th scope="col">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {familias.map((familia) => (
                            <ItemFamilia
                                key={parseInt(familia.id)}
                                familia={familia}
                                setIsLoad={setIsLoad}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </Fragment>
    )
}

export default withRouter(Familias)
